(() => {
  angular
    .module('app')
    .controller(
      'host.views.debugTools.patchMyInclusiveTaxLicensingFee.index',
      PatchMyInclusiveTaxLicensingFeeController
    );

  PatchMyInclusiveTaxLicensingFeeController.$inject = [
    '$scope',
    '$window',
    'abp.services.app.debugTool',
  ];

  function PatchMyInclusiveTaxLicensingFeeController($scope, $window, debugToolSvc) {
    const vm = this;

    vm.previewing = false;
    vm.patching = false;
    vm.previewResult = null;
    vm.patchResult = null;
    vm.modificationRemarks = '';

    vm.preview = preview;
    vm.patch = patch;
    vm.downloadCsv = downloadCsv;
    vm.canPatch = canPatch;

    $scope.$on('$viewContentLoaded', () => {
      App.initAjax();
    });

    function preview() {
      vm.previewResult = null;
      vm.patchResult = null;
      vm.modificationRemarks = '';

      vm.previewing = true;
      debugToolSvc
        .patchMyInclusiveTaxLicensingFee({ isPatch: false, modificationRemarks: '' })
        .success((data) => {
          vm.previewResult = data;
          if (data.affectedCount > 0) {
            abp.notify.success(`${data.affectedCount} affected ticket(s) found. Review the CSV before patching.`);
          } else {
            abp.notify.info('No affected tickets found. Nothing to patch.');
          }
        })
        .error((err) => {
          abp.notify.error(err && err.message ? err.message : 'Preview failed. Please try again.');
        })
        .finally(() => {
          vm.previewing = false;
        });
    }

    function canPatch() {
      return (
        vm.previewResult != null &&
        vm.previewResult.affectedCount > 0 &&
        vm.modificationRemarks.trim().length > 0
      );
    }

    function patch() {
      if (!canPatch() || vm.patching) return;

      abp.message.confirm(
        `This will enqueue ${vm.previewResult.affectedCount} background job(s) to create corrective billing records. This cannot be undone.`,
        'Confirm patch?',
        (confirmed) => {
          if (!confirmed) return;

          vm.patching = true;
          debugToolSvc
            .patchMyInclusiveTaxLicensingFee({
              isPatch: true,
              modificationRemarks: vm.modificationRemarks.trim(),
            })
            .success((data) => {
              vm.patchResult = data;
              vm.previewResult = null;
              abp.notify.success(`${data.enqueuedCount} background job(s) enqueued. Patching is running in the background.`);
            })
            .error((err) => {
              abp.notify.error(err && err.message ? err.message : 'Patch failed. Please try again.');
            })
            .finally(() => {
              vm.patching = false;
            });
        }
      );
    }

    function downloadCsv() {
      if (!vm.previewResult || !vm.previewResult.affectedTicketsFile) return;
      $window.location.assign(vm.previewResult.affectedTicketsFile.fileToken);
    }
  }
})();
